"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var lodash_1 = require("lodash");
var rc_menu_1 = __importStar(require("rc-menu"));
var react_2 = require("react");
var md_1 = require("react-icons/md");
var style_1 = require("../../../style");
var data_display_1 = require("../../data-display");
var styles_1 = require("./styles");
var MenuItemInternal = function (_a) {
    var icon = _a.icon, label = _a.label, badge = _a.badge, badgeColor = _a.badgeColor, theme = _a.theme, _b = _a.hasSubMenu, hasSubMenu = _b === void 0 ? false : _b;
    return (react_1.jsx(react_2.Fragment, null,
        react_1.jsx("span", { css: styles_1.iconAndLabelWrapperStyles },
            react_1.jsx("span", { css: styles_1.iconWrapperStyles }, icon),
            react_1.jsx("span", { css: styles_1.labelStyles }, label)),
        react_1.jsx("span", { css: styles_1.suffixStyles(hasSubMenu) }, !lodash_1.isNil(badge) && (react_1.jsx(data_display_1.Badge, { color: badgeColor, mode: theme }, badge)))));
};
var Navigation = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, _c = _a.theme, navTheme = _c === void 0 ? 'light' : _c, rcMenuProps = __rest(_a, ["items", "theme"]);
    var uxTheme = style_1.useTheme();
    var renderMenuItem = react_2.useCallback(function (menuItem, level) {
        if (level === void 0) { level = 0; }
        var key = menuItem.key, icon = menuItem.icon, badge = menuItem.badge, label = menuItem.label, disabled = menuItem.disabled, children = menuItem.children;
        var badgeColor = disabled || navTheme === 'dark' ? 'gray' : 'success';
        if (lodash_1.isEmpty(children)) {
            return (react_1.jsx(rc_menu_1.MenuItem, { key: key, style: { paddingLeft: level * 24 }, disabled: disabled },
                react_1.jsx(MenuItemInternal, { icon: icon, label: label, badge: badge, badgeColor: badgeColor, theme: navTheme })));
        }
        return (react_1.jsx(rc_menu_1.SubMenu, { key: key, style: { paddingLeft: level * 24 }, disabled: disabled, title: react_1.jsx(MenuItemInternal, { icon: icon, label: label, badge: badge, badgeColor: badgeColor, theme: navTheme, hasSubMenu: true }) }, children === null || children === void 0 ? void 0 : children.map(function (item) { return renderMenuItem(item, level + 1); })));
    }, [navTheme]);
    var style = react_2.useMemo(function () { return styles_1.getMenuStyle(uxTheme, navTheme); }, [navTheme, uxTheme]);
    return (react_1.jsx(react_2.Fragment, null,
        react_1.jsx(react_1.Global, { styles: style }),
        react_1.jsx("div", { className: navTheme },
            react_1.jsx(rc_menu_1.default, __assign({ expandIcon: react_1.jsx(md_1.MdChevronRight, { size: 20, className: "rc-menu-submenu-arrow" }) }, rcMenuProps, { mode: "inline", inlineIndent: 0 }), items.map(function (item) { return renderMenuItem(item, 0); })))));
};
exports.default = Navigation;
